import React from 'react';
import { Settings, Bell, HelpCircle, LogOut, ChevronRight } from 'lucide-react';
export function ProfiloScreen() {
  const menuItems = [{
    id: 1,
    label: 'Impostazioni',
    icon: Settings,
    action: 'settings'
  }, {
    id: 2,
    label: 'Notifiche',
    icon: Bell,
    action: 'notifications'
  }, {
    id: 3,
    label: 'Aiuto e supporto',
    icon: HelpCircle,
    action: 'help'
  }];
  return <div className="h-full overflow-y-auto bg-white" data-id="element-269">
      <div className="px-5 py-6" data-id="element-270">
        <p className="text-sm text-gray-500 mb-8" data-id="element-271">Gestisci il tuo account</p>

        {/* Profile Card */}
        <div className="pb-6 mb-6 border-b border-gray-100" data-id="element-272">
          <div className="flex items-center gap-3 mb-6" data-id="element-273">
            <div className="w-14 h-14 rounded-full flex items-center justify-center text-xl font-light text-white" style={{
            backgroundColor: '#6C083B'
          }} data-id="element-274">
              MS
            </div>
            <div className="flex-1" data-id="element-275">
              <h2 className="text-base text-gray-900 mb-0.5" data-id="element-276">
                Mario Sommelier
              </h2>
              <p className="text-sm text-gray-500" data-id="element-277">mario@example.com</p>
            </div>
          </div>

          <div className="grid grid-cols-3 gap-6" data-id="element-278">
            <div data-id="element-279">
              <p className="text-2xl font-light text-gray-900 mb-1" data-id="element-280">127</p>
              <p className="text-xs text-gray-500" data-id="element-281">Bottiglie</p>
            </div>
            <div data-id="element-282">
              <p className="text-2xl font-light text-gray-900 mb-1" data-id="element-283">24</p>
              <p className="text-xs text-gray-500" data-id="element-284">Esperienze</p>
            </div>
            <div data-id="element-285">
              <p className="text-2xl font-light text-gray-900 mb-1" data-id="element-286">€8.4K</p>
              <p className="text-xs text-gray-500" data-id="element-287">Valore</p>
            </div>
          </div>
        </div>

        {/* Menu Items */}
        <div className="mb-6" data-id="element-288">
          {menuItems.map(item => {
          const Icon = item.icon;
          return <button key={item.id} className="w-full flex items-center gap-3 py-4 border-b border-gray-100 text-left hover:border-gray-300 transition-colors" data-id="element-289">
                <Icon size={18} style={{
              color: '#6C083B'
            }} strokeWidth={1.5} data-id="element-290" />
                <span className="flex-1 text-sm text-gray-900" data-id="element-291">
                  {item.label}
                </span>
                <ChevronRight size={16} className="text-gray-400" strokeWidth={1.5} data-id="element-292" />
              </button>;
        })}
        </div>

        {/* Logout Button */}
        <button className="w-full flex items-center gap-3 py-4 border-b border-gray-100 hover:border-gray-300 transition-colors" data-id="element-293">
          <LogOut size={18} className="text-red-600" strokeWidth={1.5} data-id="element-294" />
          <span className="flex-1 text-sm text-red-600 text-left" data-id="element-295">Esci</span>
        </button>

        {/* Version */}
        <p className="text-center text-xs text-gray-400 mt-8" data-id="element-296">Versione 1.0.0</p>
      </div>
    </div>;
}